import { useQuery, QueryResult } from '@apollo/client';
// Api
import { GET_MY_ENTITLEMENTS } from 'api/brandSubscriptions/queries';
// Types
import {
  GetMyEntitlements,
  GetMyEntitlementsVariables,
} from 'api/brandSubscriptions/types/GetMyEntitlements';

type UseGetMyEntitlementsOptions = {
  ownerId: string | null | undefined;
  skip?: boolean;
};

export const useGetMyEntitlements = ({
  ownerId,
  skip = false,
}: UseGetMyEntitlementsOptions): QueryResult<
  GetMyEntitlements,
  GetMyEntitlementsVariables
> => {
  return useQuery<GetMyEntitlements, GetMyEntitlementsVariables>(
    GET_MY_ENTITLEMENTS,
    {
      variables: {
        input: {
          ownerId: ownerId || null,
        },
      },
      skip: skip || !ownerId,
      fetchPolicy: 'cache-and-network',
    }
  );
};
